import { Container, Graphics, Sprite, Texture } from "pixi.js";

import { AbstractBitmapText } from "../graphics/AbstractBitmapText";
import { AbstractSpine } from "../graphics/AbstractSpine";

export const generateScaledSprite = (textureName: string): Sprite => {
    const texture = Texture.from(textureName);

    const sprite = new Sprite(texture);
    sprite.name = textureName;
    sprite.scale.set(0.5);

    return sprite;
};

export const fitDisplayObjectToWidth = (
    displayObject: Sprite | AbstractSpine | Graphics | Container | AbstractBitmapText,
    maxWidth: number
): void => {
    if (displayObject.width > maxWidth) {
        displayObject.width = maxWidth;
        displayObject.scale.y = displayObject.scale.x;
    }
};
